import { FC, ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { useUserSettings } from "../../../context/userSettingsContext";
import { useI18n } from "../../../hooks/useTranslations";
import SvgCarRental from "../../icons/CarRental";
import SvgCarRepair from "../../icons/CarRepair";
import SvgEventNote from "../../icons/EventNote";
import SvgPlate from "../../icons/Money";
import SvgMoreHoriz from "../../icons/MoreHoriz";
import SvgPayments from "../../icons/Payments";
import Nav, { NavItemNotification } from "../Nav";

type OthersMenuProps = {
  closeSidebar: () => void;
};

const OthersMenu: FC<OthersMenuProps> = ({ closeSidebar }) => {
  const i18n = useI18n();
  const userSettings = useUserSettings();
  const navigate = useNavigate();

  const leasingNotification: NavItemNotification | undefined =
    userSettings.notifications?.carLeasingExpiringSoon || userSettings.notifications?.carLeasingExpired
      ? {
          number:
            (userSettings.notifications?.carLeasingExpired ?? 0) +
            (userSettings.notifications?.carLeasingExpiringSoon ?? 0),
          color: (userSettings.notifications?.carLeasingExpired ?? 0) > 0 ? "red" : "yellow",
          onClick: () => {
            navigate("/admin/car_leasings/issues");
            closeSidebar();
          },
        }
      : undefined;

  const others: ReactNode[] = [];

  if (userSettings.permissions.carLeasings.read) {
    others.push(
      <Nav.Item
        key="/admin/car_leasings"
        text={i18n.t.carLeasings.plural}
        to="/admin/car_leasings"
        icon={SvgCarRental}
        onClick={closeSidebar}
        notification={leasingNotification}
      />,
    );
  }

  if (userSettings.permissions.carPlates.read) {
    others.push(
      <Nav.Item
        key="/admin/car_plates"
        text={i18n.t.carPlates.plural}
        to="/admin/car_plates"
        icon={SvgPlate}
        onClick={closeSidebar}
      />,
    );
  }

  if (userSettings.permissions.costs.read) {
    others.push(
      <Nav.Item
        key="/admin/costs"
        text={i18n.t.costs.plural}
        to="/admin/costs"
        icon={SvgPayments}
        onClick={closeSidebar}
      />,
    );
  }

  if (userSettings.permissions.carPlannings.read) {
    others.push(
      <Nav.Item
        key="/admin/car_plannings"
        text={i18n.t.carPlannings.plural}
        to="/admin/car_plannings"
        icon={SvgEventNote}
        onClick={closeSidebar}
      />,
    );
  }

  if (userSettings.permissions.rentalCars.read) {
    others.push(
      <Nav.Item
        key="/admin/rental_cars"
        text={i18n.t.rentalCars.plural}
        to="/admin/rental_cars"
        icon={SvgCarRepair}
        onClick={closeSidebar}
      />,
    );
  }

  if (others.length === 0) {
    return <></>;
  }

  return (
    <Nav.Item text={i18n.t.common.others} icon={SvgMoreHoriz} groupId="menu_others">
      <Nav.List>{others}</Nav.List>
    </Nav.Item>
  );
};

export default OthersMenu;
